import { render, staticRenderFns } from "./DataIframe.vue?vue&type=template&id=378d6b2d"
import script from "./DataIframe.vue?vue&type=script&lang=js"
export * from "./DataIframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports